import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { actions as snactions } from 'store/snackbar'

const useSnackbar = (str) => {
  const dispatch = useDispatch()
  return useCallback(() => {
    dispatch(snactions.addSnackbarItem(str))
  }, [dispatch, str])
}

export default useSnackbar
